var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"boximg"},[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":_vm.img,"alt":"une image"}})]),_c('div',{staticClass:"texte"},[_c('span',{staticClass:"coloree"},[_vm._v(_vm._s(_vm.title))]),_c('br'),_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }